import { Text, Box } from '@cdl/heartbeat-react';

interface Props {
  message: string;
}

export const OverlayMessage: React.FC<Props> = ({ message }) => {
  return (
    <Box
      transform='translate(-50%, -50%)'
      bgColor='neutral.0'
      position='absolute'
      top='50%'
      left='50%'
      width='15.625rem'
      textAlign='center'
      p='xl'
      borderRadius='4px'
      shadow={400}
    >
      <Text>{message}</Text>
    </Box>
  );
};
